import {svgIconWrapper} from '../svg-icon-wrapper';

import CalendarPenRegularReport from './calendar-pen-regular-report-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CalendarPenRegularReport {...validProps} />;
}

SvgComponent.iconName = 'calendar-pen-regular-report';

export const CalendarPenRegularReportIcon = svgIconWrapper(SvgComponent);
